import React, { FC, memo } from "react";
import { CSSObject } from "styled-components";

// DLS
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

// styles
import { CloseIconContainer } from "./styles";

interface CloseIconProps {
    onClose?: () => void;
    isFtuBottomsheet?: boolean;
    dataTestId: string;
    styles?: CSSObject;
}

const CloseIcon: FC<CloseIconProps> = ({ onClose, isFtuBottomsheet = false, styles, dataTestId }) => {
    return (
        <CloseIconContainer
            data-testid={dataTestId}
            onClick={onClose}
            isFtuBottomsheet={isFtuBottomsheet}
            styles={styles}
        >
            <SpriteIconWeb iconName="close12" fillColor="text_High_Emphasis" />
        </CloseIconContainer>
    );
};

export default memo(CloseIcon);
